/**
 * Where the FleetHub login sends a user after a successful sign-in (PLA-861).
 *
 * A deep link to a protected FleetHub sub-route (today only the PSP view at
 * `/fleethub/overview`) sends logged-out visitors to
 * `/fleethub/login?returnTo=FleetHubOverview`. Only allow-listed route names
 * are honoured; anything else falls back to the regular dashboard, so the
 * query parameter can never navigate somewhere unexpected.
 *
 * @module navigators/fleetHubReturnTo
 */

/** Routes the login may return to after sign-in. */
export const FLEETHUB_RETURN_ROUTES = ["FleetHubOverview"] as const

export type FleetHubReturnRoute = (typeof FLEETHUB_RETURN_ROUTES)[number]

/** Resolve the post-login route from the (untrusted) `returnTo` param. */
export function resolveFleetHubReturnRoute(value: unknown): "FleetHub" | FleetHubReturnRoute {
  return (FLEETHUB_RETURN_ROUTES as readonly unknown[]).includes(value)
    ? (value as FleetHubReturnRoute)
    : "FleetHub"
}
